'use strict';
/*eslint-disable */
// P for Pipl

var P = window.P || {
  search_id: null,
  csrftoken_cookie_name: null,
};

// Django CSRF protection as described in the Django docs

$(document).ajaxSend(function (event, xhr, settings) {
  function getCookie (name) {
    var cookieValue = null;
    if (document.cookie && document.cookie != '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = jQuery.trim(cookies[i]);
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) == name + '=') {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }

  function sameOrigin (url) {
    // url could be relative or scheme relative or absolute
    var host = document.location.host; // host + port
    var protocol = document.location.protocol;
    var sr_origin = '//' + host;
    var origin = protocol + sr_origin;
    // Allow absolute or scheme relative URLs to same origin
    return (
      url == origin ||
      url.slice(0, origin.length + 1) == origin + '/' ||
      (url == sr_origin || url.slice(0, sr_origin.length + 1) == sr_origin + '/') ||
      // or any other URL that isn't scheme relative or absolute i.e relative.
      !/^(\/\/|http:|https:).*/.test(url)
    );
  }

  function safeMethod (method) {
    return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
  }

  if (!safeMethod(settings.type) && sameOrigin(settings.url)) {
    xhr.setRequestHeader('X-CSRFToken', getCookie(P.csrftoken_cookie_name));
  }
});

P.C = P.C || new Common();

function Common () {
  this.top_panel = undefined;
  var lastWindowWidth = 0;
  var cache = {};
  var lastXhr;
  var maxResults = 15;
  var updateInterval = 0;
  var updateEvery = 10;
  var runningCats = [
    gettext('Social Profiles'),
    gettext('Contact Details'),
    gettext('News Articles'),
    gettext('Professional Profiles'),
    gettext('Public Records'),
    gettext('Address History'),
    gettext('Criminal Records'),
    gettext('Phone Directories'),
    gettext('Archives'),
    gettext('Professional Licenses'),
    gettext('Blogs'),
    gettext('Background Reports'),
    gettext('Publications'),
    gettext('Court Records'),
    gettext('Patents'),
    gettext('School Records'),
  ];

  var titleChange = [
    gettext('Hold on to your chair, it\'s coming...'),
    gettext('Get ready to be blown away...'),
    gettext('Prepare to be amazed...'),
    gettext('Ready, set, and...'),
    gettext('Stay with us, we\'re almost there...'),
    gettext('Good things come to those who wait...'),
    gettext('Hold on, this is going to be good...'),
    gettext('Coming in three, two, one, and...'),
  ];
  var runningIndex = 0;
  var runningCounter = 1;
  var titleChanged = false;
  var loadingHtml =
    '<div class="o-main">' +
    '<div id="lan_center" class="center">' +
    '<div id="content" class="progressbar">' +
    '<h1 class="blue-title">' +
    gettext('Searching the deep web. Please wait...') +
    '</h1>' +
    '<p id="current_cat">' +
    runningCats[0] +
    '...</p>' +
    '</div></div></div>';

  function cleanACTerm (term) {
    return term
      .toLowerCase()
      .replace(/,/gi, '')
      .replace(/-/gi, ''); //anything else?
  }

  this.getLocations = function (request, response) {
    var term = request.term;
    request.limit = maxResults;
    if (term in cache) {
      response(cache[term]);
      return;
    } else {
      //get closest term that exists in cache
      for (
        var closestTerm = term.substring(0, term.length - 1);
        closestTerm;
        closestTerm = closestTerm.substring(0, closestTerm.length - 1)
      )
        if (closestTerm in cache) break;

      if (closestTerm) {
        //filter specific cached response
        var list = cache[closestTerm];
        var newList = [];
        var cleanTerm = cleanACTerm(term);
        for (var i = 0; i < list.length; i++)
          if (cleanACTerm(list[i].value).indexOf(cleanTerm) > -1) newList.push(list[i]);

        response(newList);
      }
    }

    if (typeof lastXhr !== 'undefined') lastXhr.abort();

    lastXhr = $.getJSON('/locationautocomplete/', request, function (data, status, xhr) {
      cache[term] = data;
      if (xhr === lastXhr) {
        response(data);
      }
    });
  };

  this.abortLastXHR = function () {
    lastXhr.abort();
  };

  this.get_top_vals_from_query = function (q) {
    try {
      if (typeof q === 'object' && q.length > 1) q = q[q.length - 1];
      var splitted_q = q.split('&');
      var s_val, l_val;
      var temp;
      for (var i = 0; i < splitted_q.length; i++) {
        temp = splitted_q[i].split('=');
        if (temp.length < 2) continue;
        if (temp[0].toLowerCase() == 'q') {
          s_val = decodeURIComponent(temp[1]).replace(/(?!^)\+/g, ' ');
        }
        if (temp[0].toLowerCase() == 'l') l_val = decodeURIComponent(temp[1]).replace(/\+/g, ' ');
      }
      return [s_val, l_val];
    } catch (e) {
      return [undefined, undefined];
    }
  };

  this.pageLoadBarInit = function (s_val, l_val) {
    $('body')
      .children(':not(script, style, #js-top-search)')
      .hide();
    $(window).trigger('scroll');
    window.scrollTo(0, 0);
    var $head = $('#js-top-search');
    if (!$head.length) {
      if (this.top_panel) {
        // if $js-top-search not on page we will load it from JS
        $('body').prepend(this.top_panel);
        $head = $('#js-top-search');
      } else {
        return;
      }
    }

    $head.css({top: '0px'});
    if (typeof s_val !== 'undefined') {
      $head.find('#findall').val(s_val);
    }
    if (typeof l_val !== 'undefined') {
      $head.find('#findlocation').val(l_val);
    }

    if (P.subscription_balance >= 0) {
      loadingHtml = $(loadingHtml);
      loadingHtml
        .find('#title_loading')
        .text(gettext('Searching the deep web, your search credit balance was updated, Please wait...'));
    }

    $head.after(loadingHtml);
    $('#progressbar')
      .removeClass('hidden')
      .progressbar({value: 1});
    updateInterval = setInterval('P.C.updateProgressBar()', 15);
  };

  this.updateProgressBar = function () {
    var $progressbar = $('#progressbar');
    var current = $progressbar.progressbar('value');
    runningCounter++;
    if (runningCounter > updateEvery) {
      $('#current_cat').html(runningCats[++runningIndex % (runningCats.length - 1)] + '...');
      runningCounter = 0;
    }

    if (current < 100) {
      current += (100 - current) / 100;
      $progressbar.progressbar('value', current);
      if (current > 70 && !titleChanged) {
        titleChanged = true;
        var title = titleChange[Math.floor(Math.random() * titleChange.length)];
        if (P.subscription_balance >= 0) {
          title += gettext(' your search credit balance was updated, please wait...');
        }
        $('#title_loading').html(title);
      }
    } else {
      clearInterval(updateInterval);
    }
  };

  this.user_notify = function (a, b) {
    // TODO: Implement
    console.log(a + ': ' + b);
  };

  this.close_popup = function () {
    // hide login form, move to invisible div
    $('#lf').append($('#wrapper_alert'));
  };

  function initAutocomplete () {
    $('#findlocation, #filter-mobile-loc')
      .on('focus', function () {
        $('input[name=\'sloc\']').val('');
      })
      .autocomplete({
        minLength: 2,
        delay: 70,
        autoFocus: true,
        source: P.C.getLocations,
        select: function (event, ui) {
          P.C.abortLastXHR();
          $('input[name=\'sloc\']').val(ui.item.id);
        },
        search: function (event, ui) {
          $('input[name=\'sloc\']').val('');
        },
      });
  }

  function initSmartMenu () {
    var $lanHead = $('#js-top-search.top-search, header nav[data-smart-menu]');
    if ($lanHead.length > 0) {
      require('./vendor/smart.menu.pipl.js');
      $lanHead.smartMenu();
    }
  }

  function initSideBar () {
    var $sidebar = $('#sidebar');

    function initLinks () {
      var links = $sidebar.find('[data-role=side-bar-link]');

      function hide () {
        links.each(function () {
          var $this = $(this);
          if ($this.hasClass('selected')) {
            var $self = $this;
            $self.removeClass('selected');
            $('#' + $(this).data('div-trigger')).slideUp(function () {
              $('#' + $self.data('div-trigger')).hide();
            });
          } else {
            $this.removeClass('selected');
            $('#' + $this.data('div-trigger')).hide();
          }
        });
      }

      function show ($link) {
        hide($link);
        $link.addClass('selected');
        $('#' + $link.data('div-trigger')).slideDown();
      }

      links.each(function () {
        $(this).click(function () {
          var $link = $(this);
          if ($link.hasClass('selected')) {
            hide();
          } else {
            show($link);
          }
        });
      });
    }

    initLinks();
  }

  function initScreenWidthDetector () {
    var setResolution = function () {
      var cookieName = 'resolution';
      var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      document.cookie =
        cookieName +
        '=' +
        width +
        ':' +
        height +
        ':' +
        (window.devicePixelRatio ? window.devicePixelRatio : 1) +
        '; path=/';
    };
    setResolution();
    $(window).resize(function () {
      setResolution();
      lastWindowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    });
  }

  function counterSearchRecords () {
    var $searchRecords = $('#js-search-number');
    var numberWithCommas = function (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    if ($searchRecords) {
      var startFrom = new Date().getTime() / 1000;
      var startNumber = parseInt($searchRecords.text().replace(/,/gi, ''));

      $searchRecords.animate({
        Counter: startNumber,
      });

      var incrementNumber = function () {
        var timeFromUnix = new Date().getTime() / 1000;
        var records = parseInt(startNumber + (timeFromUnix - startFrom) * 3);
        $searchRecords.animate(
          {
            Counter: records,
          },
          {
            duration: 1000,
            easing: 'swing',
            step: function (now) {
              $(this).text(numberWithCommas(parseInt(Math.ceil(now))));
            },
          },
        );
      };
      incrementNumber();
      setInterval(incrementNumber, 2000);
    }
  }

  function logoSlider () {
    var $logoContainer = $('.c-partners-images ul');
    if ($logoContainer.length > 0) {
      var $containerLogos = $logoContainer.first().addClass('current');

      setInterval(function () {
        $containerLogos.fadeOut(2000, function () {
          $containerLogos.removeClass('current');
          if ($containerLogos.next().length) {
            $containerLogos = $containerLogos
              .next()
              .fadeIn(2000)
              .addClass('current');
          } else {
            $containerLogos = $logoContainer
              .first()
              .fadeIn(2000)
              .addClass('current');
          }
        });
      }, 6000);
    }
  }

  function initLangMenu () {
    var $langMenu = $('#lang-form');
    if ($langMenu.length > 0) {
      $('#js-menu-options')
        .find('li')
        .on('click', function () {
          if (!$('#js-menu-options').hasClass('open')) return true;

          $langMenu.find('#js-language').val(
            $(this)
              .find('a')
              .attr('data-lang'),
          );
          $langMenu.submit();
          return false;
        });
    }
  }

  this.isMobileScreen = function () {
    // Determine if user is onMobile version of the site
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return width <= 1179;
  };
  this.init = function () {
    var self = this;
    initAutocomplete();
    initSmartMenu();
    initSideBar();
    initScreenWidthDetector();
    initLangMenu();
    logoSlider();
    counterSearchRecords();

    // TODO: for some reason the sloc field is not reaching the server if this handler is attached.
    // Generic forms submit handler (Not sure why we need this)

    // An Rest input button
    $('.input_remove').click(function () {
      var $filter_age = $('#filter-age');
      var $filter_loc = $('#filter-loc');

      //resting all inputs in the advanced StripeIntegratedForm
      $('#advanced_search_form')
        .find('input')
        .not(':button, :submit, :reset, :checkbox')
        .val('');

      $('#findall').val('');

      $('div[data-div-trigger=filters-locations]').removeClass('has-selected');
      $('div[data-div-trigger=filters-ages]')
        .html('Age <span class="arrow"></span>')
        .removeClass('has-selected');

      $filter_age.find('input.all').attr('checked', 'checked');
      $filter_age.find('input[name=fage]').removeAttr('checked');

      $filter_loc.find('input.all').attr('checked', 'checked');
      $filter_loc.find('input[name=floc]').removeAttr('checked');

      $('#filter-mobile-loc').val('');
      $('#findlocation').val('');
    });

    $('form#advanced_search_form').submit(function (e) {
      if (self.isMobileScreen() && $('#filters-locations:visible').length > 0 && !window.CHECBOX_CHECKED) {
        e.preventDefault();
        $('#head_login')
          .find('.search-form form')
          .submit();
        return false;
      }

      P.C.pageLoadBarInit();
    });

    // Querying all form that should trigger loading bar on submit
    $('form.js-init-progress-bar').on('submit', function (e) {
      e.preventDefault();

      const queryParams = $('form.js-init-progress-bar').serialize();
      window.reactHistory.push(`/search/?${queryParams}`);
      $('.django-app').remove();
      $('.top-search').remove();
      $('.o-main').remove();
      $('#content').remove();
      $('.o-main-wrapper').show();
      return false;

      if (self.isMobileScreen() && $('div.selected[data-div-trigger=advanced_search]').length > 0) {
        // On mobile, when "Advanced" menu is open,
        // the Top Nav Submit button, should submit the "Advanced" form
        e.preventDefault();
        $('#advanced_search_form').submit();
        return false;
      }
      var $form = $(this);
      var s_val = $form.find('#findall').val();
      var l_val = $form.find('#findlocation').val();
      if (self.isMobileScreen()) {
        l_val = $('#filter-mobile-loc').val();
        if (l_val == '') $('input[name=sloc]').val('');
      }
      P.C.pageLoadBarInit(s_val, l_val);
    });

    // Generic click handler for links that require a progress bar (Not sure selectors are still correct)
    $('.profile_result_content.search_link a, #profile_table #profile_fields a, a.progressbar, a.search_link')
      .not('.shortcuts_link')
      .on('click', function (e) {
        if ($(this).attr('target') == '_blank') {
          return true;
        }

        if (!e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey && e.which != 2) {
          var q = this.href.split('?');
          var vals = P.C.get_top_vals_from_query(q);
          console.log(q, vals);
          P.C.pageLoadBarInit(vals[0], vals[1]);
        }
      });

    if ($(window).width() < 460) {
      $('#findall').attr('placeholder', gettext('Name, Email or Phone'));
    }

    (function () {
      // var beforePrint = function() {
      //   window.lazyLoaderManager.forceLoad();
      // };
      // var afterPrint = function() {};
      // if (window.matchMedia) {
      //   var mediaQueryList = window.matchMedia('print');
      //   mediaQueryList.addListener(function(mql) {
      //     if (mql.matches) {
      //       beforePrint();
      //     } else {
      //       afterPrint();
      //     }
      //   });
      // }
      // window.onbeforeprint = beforePrint;
      // window.onafterprint = afterPrint;
    })();
  };
}

$(function () {
  P.C.init();
});

const DJANGO_URLS = [
  '/bot/',
  '/help/identity-resolution',
  '/help/bot/',
  '/help/deep-web/',
  '/help/',
  '/moosh/',
  '/jobs/',
  '/tos/',
  '/careers/',
  '/contact/other/',
  '/contact/',
  '/help/remove/',
  '/privacy-shield-notice/',
  '/privacy/',
  '/gdpr/dpa/',
  '/gdpr/',
  '/help/summary/',
];

window.addEventListener('popstate', event => {
  const {pathname} = window.location;

  if (DJANGO_URLS.includes(pathname)) {
    event.stopPropagation();
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.reload();
  }
});
